import { useState, useContext } from 'react';
import { useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';

import { UESupport, StyledPaper } from '../../components/common';
import { Tab, Tabs } from '../../components/common/Tabs';
import TabPanel from './TabPanel';
import FarmSelect from '../../components/FarmSelect/FarmSelect';
import colors from '../../assets/colors';
import FarmContext from '../../store/farm-context';

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}

export default function AssesmentScreenContent() {
  const startYear = 2016;
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );
  const [value, setValue] = useState(4);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const farmCTX = useContext(FarmContext);
  const theme = useTheme();

  const changeYear = (year) => {
    const index = years.findIndex((y) => y === year);
    if (index === value) return;
    setValue(index);
  };

  return (
    <>
      <FarmSelect />
      {farmCTX.farmID !== null && (
        <StyledPaper>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Box sx={{ width: '100%', bgcolor: colors.oldAgroweGreen }}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons={true}
                allowScrollButtonsMobile
                aria-label="scrollable force tabs example"
              >
                {years.map((year, index) => (
                  <Tab label={year} {...a11yProps(index)} key={year} />
                ))}
              </Tabs>
            </Box>
            {years.map((year, index) => (
              <TabPanel
                year={year}
                value={value}
                index={index}
                key={year}
                changeYear={changeYear}
              />
            ))}
          </Box>
        </StyledPaper>
      )}
      <UESupport />
    </>
  );
}
